import { memo } from 'react';
import { Select } from '@shared/ui/inputs/select/index';
import type { SelectPT } from '@shared/ui/inputs/select/ui.tsx';

type PT = SelectPT;

const paymentMethod = [
  { forUser: 'Интернет эквайринг', value: 'O' },
  { forUser: 'Наличные', value: 'C' },
];

export const SelectPaymentMethod = memo((props: PT) => (
  <Select values={paymentMethod} label={'Способ оплаты'} defaultValue {...props} />
));
